import { LogOut, Newspaper, Settings, Upload } from 'lucide-react';
import { NavLink, Navigate, Outlet } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/hooks/useAuth';
import { cn } from '@/utils/cn';

const adminNav = [
  { to: '/admin', label: 'Dashboard', icon: Newspaper },
  { to: '/admin/media', label: 'Medios', icon: Upload },
  { to: '/admin/configuracion', label: 'Config', icon: Settings }
];

export function AdminLayout() {
  const { session, signOut } = useAuth();

  if (!session) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <div className="min-h-dvh bg-divergent-black text-divergent-white">
      <aside className="fixed inset-x-0 top-0 z-30 border-b border-white/10 bg-divergent-surface/95">
        <div className="safe-px mx-auto flex h-16 max-w-6xl items-center justify-between">
          <NavLink to="/admin" className="font-semibold">
            El Divergente Admin
          </NavLink>
          <Button variant="ghost" icon={LogOut} onClick={signOut}>
            Salir
          </Button>
        </div>
      </aside>
      <div className="safe-px mx-auto grid min-h-dvh max-w-6xl gap-6 pt-24 md:grid-cols-[220px_1fr]">
        <nav className="hidden md:block">
          <div className="sticky top-24 space-y-2">
            {adminNav.map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                end={to === '/admin'}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-3 rounded px-3 py-2 text-sm text-white/65 transition hover:bg-white/10 hover:text-white',
                    isActive && 'bg-divergent-yellow text-black hover:bg-divergent-yellow hover:text-black'
                  )
                }
              >
                <Icon size={18} aria-hidden="true" />
                {label}
              </NavLink>
            ))}
          </div>
        </nav>
        <main className="pb-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
